import cn from './cn.png';
import jp from './jp.png';
import gb from './gb.png';
export default { cn, jp, gb }